import React, { Component, Fragment } from "react";

// Externals
import classNames from "classnames";
import compose from "recompose/compose";
import PropTypes from "prop-types";

// Material helpers
import { withStyles, withWidth } from "@material-ui/core";

// Material components
import { Drawer } from "@material-ui/core";

// Custom components
import {
  Sidebar,
  Topbar
  // Footer
} from "./components";

// Component styles
import styles from "./styles";
//connect redux for language
import { connect } from "react-redux";
import { userLanguage, userLogout } from "../../redux/actions";
import Routes from "../../Routes";
import multilang from "../../language/lang.json";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    const isMobile = ["xs", "sm", "md"].includes(props.width);
    this.state = {
      isOpen: !isMobile,
      title: ""
    };
  }
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      Routes[1].forEach(item => {
        if (item.link === this.props.location.pathname)
          this.setState({ title: item.name });
      });
    }
  }
  componentDidMount() {
    Routes[1].forEach(item => {
      if (item.link === this.props.location.pathname)
        this.setState({ title: item.name });
    });
  }
  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleToggleOpen = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };
  handelLang = ({ lang, dir, token, id }) => {
    const { userLanguage, user } = this.props;
    userLanguage({
      lang,
      dir,
      token,
      id,
      mobile: user.mobileNumber,
      name: user.name
    });
  };

  render() {
    const {
      classes,
      width,
      children,
      language: { lang, dir },
      language,
      userLogout,
      culture
    } = this.props;

    const { isOpen, title } = this.state;
    const isMobile = ["xs", "sm", "md"].includes(width);
    const shiftTopbar = isOpen && !isMobile;
    const shiftContent = isOpen && !isMobile;

    // console.log("this.props.dashboard", this.props.location.snack);

    return (
      <Fragment>
        <Topbar
          className={
            classNames(classes.topbar, {
              [dir === "rtl"
                ? classes.topbarShift
                : classes.topbarShiftLtr]: shiftTopbar
            }) + (dir === "rtl" ? " rtl" : " ltr")
          }
          isSidebarOpen={isOpen}
          onToggleSidebar={this.handleToggleOpen}
          title={title !== "" ? multilang[title][lang] : title}
          changelang={this.handelLang}
          language={language}
          userLogout={userLogout}
          culture={culture}
        />
        <Drawer
          anchor={dir === "rtl" ? "right" : "left"}
          classes={{
            paper: classes.drawerPaper + (dir === "rtl" ? " rtl" : " ltr")
          }}
          onClose={this.handleClose}
          open={isOpen}
          variant={isMobile ? "temporary" : "persistent"}
        >
          <Sidebar
            className={classes.sidebar + (dir === "rtl" ? " rtl" : " ltr")}
            language={language}
          />
        </Drawer>
        <main
          className={
            classNames(classes.content, {
              [dir === "rtl"
                ? classes.contentShift
                : classes.contentShiftLtr]: shiftContent
            }) + (dir === "rtl" ? " rtl" : " ltr")
          }
        >
          {children}
          {/* <Footer /> */}
        </main>
      </Fragment>
    );
  }
}

Dashboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  width: PropTypes.string.isRequired
};
const mapStateToProps = state => ({
  language: state.language,
  culture: state.culture,
  user: state.user.user
});

const mapDispatchToProps = {
  userLanguage,
  userLogout
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  compose(
    withStyles(styles),
    withWidth()
  )(Dashboard)
);
